/**
 * Product card — mobile image swipe (Mejuri-style)
 *
 * The horizontal swipe itself is pure CSS (scroll-snap, see custom.css). This
 * script only keeps the two-dot indicator in sync with the scroll position and
 * binds any cards added later via pagination / infinite scroll. It is a no-op
 * on viewports >= 768px because the scroll container collapses back to a block.
 */
(function () {
  if (window.__pcardSwipeInit) return;
  window.__pcardSwipeInit = true;

  function syncDots(link) {
    var card = link.closest('.m-product-card');
    if (!card) return;

    var dotsWrap = card.querySelector('.m-product-card__dots');
    if (!dotsWrap) return;

    var dots = dotsWrap.querySelectorAll('.m-product-card__dot');
    if (!dots.length || !link.clientWidth) return;

    var index = Math.round(link.scrollLeft / link.clientWidth);
    if (index < 0) index = 0;
    if (index > dots.length - 1) index = dots.length - 1;

    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }
  }

  // A card sitting inside an m-mixed-layout that swipes/scrolls on mobile must
  // not run its own image swipe — the outer track owns the gesture. A pure
  // mobile grid (mobile-grid without mobile-scroll) is fine and keeps the swipe.
  function inMobileSlider(link) {
    var layout = link.closest('.m-mixed-layout');
    if (!layout) return false;
    var isMobileGrid = layout.classList.contains('m-mixed-layout--mobile-grid');
    var isMobileScroll = layout.classList.contains('m-mixed-layout--mobile-scroll');
    return isMobileScroll || !isMobileGrid;
  }

  function bind(link) {
    if (link.dataset.swipeBound === '1') return;
    if (inMobileSlider(link)) return;
    link.dataset.swipeBound = '1';

    var raf = null;
    link.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          syncDots(link);
        });
      },
      { passive: true }
    );
  }

  function init(root) {
    (root || document)
      .querySelectorAll('.m-product-card--mobile-swipe .m-product-card__link')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Catch cards inserted by pagination / infinite scroll / quick filters.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.m-product-card--mobile-swipe .m-product-card__link')) bind(node);
        if (node.querySelectorAll) init(node);
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
